import React from "react";

const HPageContainer = ({ children, className = "" }) => {
  return <div className={`flex flex-col h-full min-h-0 ${className}`}>{children}</div>;
};

export default HPageContainer;
